// ResponsivePaymentEntrant.jsx → src/gestion-payments/
import React from "react";
import PaymentEntrant from "./PaymentEntrant";
import PaymentsMobile from "../mobile/paiements/PaymentsMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsivePaymentEntrant(props) {
  return useIsMobile() ? <PaymentsMobile paymentType="in" {...props} /> : <PaymentEntrant {...props} />;
}
